module.exports = __webpack_public_path__ + "static/img/1_v2.1809847d.png";